import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { PlanoDeContasService } from "../../../services/plano-de-contas.service";
import { SpinnerService } from "../../../services/spinner.service";
import { ToastService } from "../../../services/toast.service";
import { TipoContaContabil } from "../../../models/enums/tipoContaContabil.enum";
import { SeveridadeToast } from "../../../models/enums/severidade-toast.enum";
import { JwtHelper } from "../../../helpers/jwtDecode.helper";
import { Icones } from "../../../shared/variaveisDeRotas";

@Component({
    selector: 'app-plano-de-conta-editar',
    templateUrl: './plano-de-contas-editar.component.html',
    styleUrl: './plano-de-contas-editar.component.scss',
})
export class PlanoDeContasEditarComponent implements OnInit {

    @Output() tituloChange = new EventEmitter<string>();
    @Output() iconeChange = new EventEmitter<string>();

    editarContaContabil: FormGroup = new FormGroup({
        id: new FormControl(''),
        codigo: new FormControl(''),
        descricao: new FormControl('', Validators.required),
        tipo: new FormControl(0),
        contaSuperior: new FormControl(''),
        nivel: new FormControl(0),
        natureza: new FormControl(0),
        saldo: new FormControl(0, Validators.required),
        maiorNivel: new FormControl(false),
        usuarioId: new FormControl(null),
    });

    constructor(
        private route: ActivatedRoute,
        private planoDeContasService: PlanoDeContasService,
        public spinnerService: SpinnerService,
        private toastService: ToastService,
        private router: Router,
        private jwtHelper: JwtHelper,
    ) {

    }

    ngOnInit(): void {
        this.tituloChange.emit('Editar Conta Contábil');
        this.iconeChange.emit(Icones.carteiraAmarelo);
        this.preencheCamposPorURL();
    }

    retornaTipo(tipo: number): string {
        switch (tipo) {
            case TipoContaContabil.A:
                return 'Analítico';
            case TipoContaContabil.S:
                return 'Sintético';
            default:
                return 'Desconhecido';
        }
    }

    onSubmit(): void {
        this.spinnerService.show('Editando conta contábil...');
        this.planoDeContasService.updatePlanoDeContas(this.editarContaContabil.getRawValue()).subscribe({
            next: (res) => {
                this.toastService.setMensagemToast('Conta contábil editada com sucesso!', SeveridadeToast.Success);
                this.router.navigate(['plano-de-contas']);
                this.spinnerService.hide();
            },
            error: (e) => {
                this.toastService.setMensagemToast(`Erro ao editar conta contábil: ${e.error}`, SeveridadeToast.Error);
                this.spinnerService.hide();
            }
        })
    }

    onCancel(): void {
        this.router.navigate(['plano-de-contas']);
    }

    async preencheCamposPorURL() {
        this.route.params.subscribe(params => {
            this.editarContaContabil.patchValue({
                id: params['id'],
                codigo: params['codigo'],
                descricao: params['descricao'],
                tipo: +params['tipo'],
                contaSuperior: params['contaSuperior'],
                nivel: +params['nivel'],
                natureza: +params['natureza'],
                saldo: +params['saldo'],
            });
            this.editarContaContabil.get('maiorNivel')?.setValue(false);
            this.editarContaContabil.get('usuarioId')?.setValue(this.jwtHelper.getUserIdFromToken());
        });
    }
}



